import React, { useEffect, useState } from 'react';
import api from '../../_helpers/api';
import axios from 'axios';
import { Loader } from 'rsuite';
import { Card } from 'Components/Common/Card/Card';

export const Receptor = (props) => {
  const { receptor, codigoGeneracion } = props;
  const [catDefsRec, setCatDefsRec] = useState({ loading: true });

  const getCATDef_Rec = () => {
    const reqs = [api.post(`${api.getUri()}CAT/CAT022`, { code: receptor.tipoDocumento })];

    if (receptor.direccion) {
      reqs.push(
        api.post(`${api.getUri()}CAT/CAT012`, { code: receptor.direccion.departamento }),
        api.post(`${api.getUri()}CAT/CAT013`, { code: receptor.direccion.municipio })
      );
    }

    if (receptor.tipoPersona) reqs.push(api.post(`${api.getUri()}CAT/CAT029`, { code: receptor.tipoPersona.toString() }));

    axios.all(reqs).then(
      axios.spread((tipoDocumento, departamento, municipio, tipoPersona) => {
        const state = {
          loading: false,
          tipoDocumento: tipoDocumento.data.items.pop(),
        };

        if (departamento) state.departamento = departamento.data.items.pop();
        if (municipio) state.municipio = municipio.data.items.pop();
        if (tipoPersona) state.tipoPersona = tipoPersona.data.items.pop();

        setCatDefsRec(state);
      })
    );
  };

  useEffect(() => {
    getCATDef_Rec();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoGeneracion]);

  return (
    <Card header={'¿Quién recibe el DTE?'}>
      <dl>
        <dt>Nombre</dt>
        <dd>{receptor.nombre}</dd>
        <dt>Tipo de documento</dt>
        <dd>{catDefsRec.loading ? <Loader /> : `${catDefsRec.tipoDocumento.code} - ${catDefsRec.tipoDocumento.value}`}</dd>
        <dt>Numero de documento</dt>
        <dd>{receptor.numDocumento}</dd>
        {receptor.nrc && (
          <>
            <dt>NRC</dt>
            <dd>{receptor.nrc}</dd>
          </>
        )}
        {receptor.nombreComercial && (
          <>
            <dt>Nombre comercial</dt>
            <dd>{receptor.nombreComercial}</dd>
          </>
        )}
        {receptor.pais && (
          <>
            <dt>Pais</dt>
            <dd>
              {receptor.codPais} - {receptor.nombrePais}
            </dd>
          </>
        )}
        {receptor.direccion && (
          <>
            <dt>Dirección</dt>
            <dd>
              {catDefsRec.loading ? (
                <Loader />
              ) : receptor.direccion ? (
                `${receptor.direccion.complemento}. ${catDefsRec.departamento.value}, ${catDefsRec.municipio.value}`
              ) : (
                `${receptor.complemento}.`
              )}
            </dd>
          </>
        )}
        {receptor.descActividad && (
          <>
            <dt>Actividad</dt>
            <dd>{receptor.descActividad}</dd>
          </>
        )}
        {receptor.telefono && (
          <>
            <dt>Teléfono</dt>
            <dd>{receptor.telefono}</dd>
          </>
        )}
        {receptor.correo && (
          <>
            <dt>Correo</dt>
            <dd>
              <a href={`mailto:${receptor.correo}`}>{receptor.correo}</a>
            </dd>
          </>
        )}
      </dl>
    </Card>
  );
};
